/**
 * Stringify a primitive for display: strings as-is, numbers and booleans
 * through `String`, anything else (`null`, `undefined`, objects, arrays)
 * as `''` — an object would otherwise render as '[object Object]'.
 */
export function stringifyPrimitive(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
}
